// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepDeviceInformationContainer__aL3fn {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.stepDeviceInformationInputsContainer__vkAEb {
  display: grid;
  row-gap: 15px;
  column-gap: 25px;
}

.stepDeviceAdditionalInformationInputsContainer__xYTJ3 {
  display: grid;
  row-gap: 15px;
  column-gap: 25px;
  grid-template-columns: 1fr 1fr;
}

.whatEnvironmentContainer__qFqEF {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.fieldLabel__YwRRo {
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}

.whatEnvironmentContainerFields__oBkx6 {
  display: grid;
  gap: 2px;
  grid-template-columns: 1fr 1fr;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/WarrantyModal/components/StepDeviceInformation/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,aAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,aAAA;EACA,gBAAA;EACA,8BAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAzEF;;AA4EA;EACE,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,QAAA;EACA,8BAAA;EACA,mBAAA;AAzEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.stepDeviceInformationContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.stepDeviceInformationInputsContainer {\n  display: grid;\n  row-gap: 15px;\n  column-gap: 25px;\n}\n\n.stepDeviceAdditionalInformationInputsContainer {\n  display: grid;\n  row-gap: 15px;\n  column-gap: 25px;\n  grid-template-columns: 1fr 1fr;\n}\n\n.whatEnvironmentContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.fieldLabel {\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.whatEnvironmentContainerFields {\n  display: grid;\n  gap: 2px;\n  grid-template-columns: 1fr 1fr;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepDeviceInformationContainer": `stepDeviceInformationContainer__aL3fn`,
	"stepDeviceInformationInputsContainer": `stepDeviceInformationInputsContainer__vkAEb`,
	"stepDeviceAdditionalInformationInputsContainer": `stepDeviceAdditionalInformationInputsContainer__xYTJ3`,
	"whatEnvironmentContainer": `whatEnvironmentContainer__qFqEF`,
	"fieldLabel": `fieldLabel__YwRRo`,
	"whatEnvironmentContainerFields": `whatEnvironmentContainerFields__oBkx6`
};
module.exports = ___CSS_LOADER_EXPORT___;
